'use client';
import React, { useCallback } from 'react';
import { RefreshControl as RNRefreshControl } from 'react-native';
import type { RefreshControlProps } from 'react-native';
import { useHaptic } from '@/hooks/useHaptic';

const RefreshControl = React.forwardRef<RNRefreshControl, RefreshControlProps>(
  ({ onRefresh, ...props }, ref) => {
    const haptic = useHaptic();

    const handleRefresh = useCallback(() => {
      haptic.impactLight();
      onRefresh?.();
    }, [onRefresh, haptic]);

    return <RNRefreshControl ref={ref} {...props} onRefresh={handleRefresh} />;
  }
);

RefreshControl.displayName = 'RefreshControl';

export { RefreshControl };
